(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["store-gallery"] && !Shopify.designMode) return;
  try {
    
  class StoreGallery {
    constructor(section) {
      this.section = section;
      this.track = section.querySelector('[data-store-gallery-track]');
      this.prevButton = section.querySelector('[data-store-gallery-prev]');
      this.nextButton = section.querySelector('[data-store-gallery-next]');
      this.dots = Array.from(section.querySelectorAll('[data-store-gallery-dot]'));
      this.slides = Array.from(section.querySelectorAll('.store-gallery__slide'));

      if (!this.track || this.slides.length < 2) return;

      this.onScroll = this.onScroll.bind(this);
      this.goToPrevious = this.goToPrevious.bind(this);
      this.goToNext = this.goToNext.bind(this);

      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.prevButton?.addEventListener('click', this.goToPrevious);
      this.nextButton?.addEventListener('click', this.goToNext);

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.goTo(Number(dot.dataset.storeGalleryDot));
        });
      });

      this.update();
    }

    get currentIndex() {
      const slideWidth = this.slides[0]?.getBoundingClientRect().width || 1;
      return Math.round(this.track.scrollLeft / slideWidth);
    }

    goTo(index) {
      const slide = this.slides[index];
      if (!slide) return;
      this.track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    }

    goToPrevious() {
      this.goTo(Math.max(this.currentIndex - 1, 0));
    }

    goToNext() {
      this.goTo(Math.min(this.currentIndex + 1, this.slides.length - 1));
    }

    onScroll() {
      window.requestAnimationFrame(() => this.update());
    }

    update() {
      const index = this.currentIndex;
      if (this.prevButton) this.prevButton.disabled = index <= 0;
      if (this.nextButton) this.nextButton.disabled = index >= this.slides.length - 1;
      this.dots.forEach((dot, dotIndex) => {
        dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false');
      });
    }
  }

  document.querySelectorAll('[data-store-gallery]').forEach((gallery) => {
    new StoreGallery(gallery);
  });

  } catch(e) { console.error(e); }
})();
})();
